class TokenService {
  private accessToken: string | null = null

  public getAccessToken(): string | null {
    return this.accessToken
  }

  public setAccessToken(token: string): void {
    this.accessToken = token
  }

  public clearTokens(): void {
    this.accessToken = null
  }
}

export const tokenService = new TokenService()
